import { Observable } from "@dooboostore/core";
var WindowUtils;
((WindowUtils2) => {
  WindowUtils2.eventObservable = (window, type, options) => {
    return new Observable((subscriber) => {
      const handler = (event) => subscriber.next(event);
      window.addEventListener(type, handler, options);
      return () => {
        window.removeEventListener(type, handler, options);
      };
    });
  };
})(WindowUtils || (WindowUtils = {}));
export {
  WindowUtils
};
//# sourceMappingURL=WindowUtils.js.map
